<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="竞争对手:" prop="competitor">
        <el-input v-model="data.competitor" :maxlength="30" placeholder="请输入竞争对手公司名称" clearable/>
      </el-form-item>
      <el-form-item label="公司网址:" prop="website">
        <el-input v-model="data.website" :maxlength="30" placeholder="请输入公司网址" clearable/>
      </el-form-item>
      <el-form-item label="公司人数:" prop="peopleNumber">
        <el-input v-model="data.peopleNumber" :maxlength="30" placeholder="请输入公司人数" clearable/>
      </el-form-item>
      <el-form-item label="所在城市" prop="area">
        <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="优势:" prop="strengths">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="data.strengths" placeholder="请输入500字以内" clearable/>
      </el-form-item>
      <el-form-item label="劣势:" prop="weaknesses">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="data.weaknesses" placeholder="请输入500字以内" clearable/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>

</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import { mapState } from 'vuex'
import { changeBusinessCompetitor, queryBusinessCompetitorByRelateId, updateBusiness } from '@/api/crm/business'
import { listAllLevelArea } from '@/api/crm/area'
import { transferCascaderOptionsForProvince } from '@/utils'

export default {
  name: "addBusinessCompetitorDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      title: '',
      areaOptions: [],
      rules: {
        competitor: [
          {required: true, message: '请输入竞争对手公司名称', trigger: 'change'}
        ],
        strengths: [
          {required: true, message: '请输入优势', trigger: 'change'},
          {max: 500, message: '长度过长', trigger: 'change'}
        ],
        weaknesses: [
          {required: true, message: '请输入劣势', trigger: 'change'},
          {max: 500, message: '长度过长', trigger: 'change'}
        ]
      },
      data: {
        id: null,
        businessId: null,
        competitor: null,
        website: null,
        provinceCode: null,
        cityCode: null,
        regionCode: null,
        area: [],
        peopleNumber: null,
        strengths: null,
        weaknesses: null
      }
    };
  },
  created() {
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    CompanyInput
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (businessId, relateId) {
      this.data.businessId = businessId;
      this.visible = true;
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      if (relateId) {
        this.title = '编辑竞争对手'
        queryBusinessCompetitorByRelateId({id:relateId}).then(response => {
          this.data.id = response.data.id;
          this.data.businessId = response.data.businessId;
          this.data.competitor = response.data.competitor;
          this.data.website = response.data.website;
          this.data.provinceCode = response.data.provinceCode;
          this.data.cityCode = response.data.cityCode;
          this.data.regionCode = response.data.regionCode;
          this.data.peopleNumber = response.data.peopleNumber;
          this.data.strengths = response.data.strengths;
          this.data.weaknesses = response.data.weaknesses;
          let area = []
          if (this.data.provinceCode) {
            area.push(this.data.provinceCode)
          }
          if (this.data.cityCode) {
            area.push(this.data.cityCode)
          }
          if (this.data.regionCode) {
            area.push(this.data.regionCode)
          }
          this.data.area = area
          loading.close()
          this.visible = true
        }).catch(error => {
          loading.close()
        })
      } else {
        this.title = '新增竞争对手'
        loading.close()
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          changeBusinessCompetitor(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("操作成功");
            this.$emit(success)
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
